// axiosGlobalInterceptor.js
import axios from "axios";
import { baseUrl } from "../../../../boot";

// const baseUrl = baseUrl

// Enable sending HttpOnly cookies
axios.defaults.withCredentials = true;

// Intercept response errors globally
axios.interceptors.response.use(
  (response) => response, // Pass through if successful
  async (error) => {
    const originalRequest = error.config;

    // If 401 and not retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try hitting refresh endpoint
        await axios.get(`${baseUrl}/vancouverapis/webapp/refresh-token`, { withCredentials: true });

        // Retry original request
        return axios(originalRequest);
      } catch (refreshError) {
        console.error("Auto-refresh failed");
        // Optionally redirect to login or clear storage
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);
